import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_PARTICIPATION_MATCHES_ERROR = 'GET_PARTICIPATION_MATCHES_ERROR';
export const GET_PARTICIPATION_MATCHES_START = 'GET_PARTICIPATION_MATCHES_START';
export const GET_PARTICIPATION_MATCHES_SUCCESS = 'GET_PARTICIPATION_MATCHES_SUCCESS';

export const RESET_PARTICIPATION_MATCHES = 'RESET_PARTICIPATION_MATCHES';

/*
  Get a list of survey jobs that are recommended based on participation matches that were recommended for this job
*/
export function getParticipationMatches(currency, currentJob, maid) {
  return async dispatch => {
    const errorMessage = 'Error retrieving participation matches';

    try {
      dispatch({ type: GET_PARTICIPATION_MATCHES_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${maid}/participation-matches`, {
        params: {
          orgJobCode: currentJob.code,
          orgJobCodeKey: currentJob.codeKey,
          currency
        }
      });

      if (result.data.status < 300) {
        dispatch({
          type: GET_PARTICIPATION_MATCHES_SUCCESS,
          status: result.data.status,
          participationMatches: result.data.data.matches
        });

        return result.data.data.matches;
      } else {
        dispatch({
          type: GET_PARTICIPATION_MATCHES_ERROR,
          status: result.data.status,
          message: result.data.reason
        });

        throw Error(errorMessage);
      }
    } catch (error) {
      // TODO: add back after debugging MDC
      // addAlert(errorMessage, 'danger');
      console.error('Catch error in getParticipationMatches: ', error);
      dispatch({ type: GET_PARTICIPATION_MATCHES_ERROR });

      return [];
    }
  };
}

export function resetParticipationMatches() {
  return { type: RESET_PARTICIPATION_MATCHES };
}
